"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault").default;
var _buttonFormAttribute = _interopRequireDefault(require("./button-form-attribute"));
/**
 * Polyfills required for some browsers that support script type="module"
 */

// Polyfill <button form="formId" ...> if needed - Edge < 16
(0, _buttonFormAttribute.default)();